import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=a66d43ee"
import script from "./NewModal.vue?vue&type=script&lang=js"
export * from "./NewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports